module.exports = __webpack_public_path__ + "img/8an-puma.183ce14d.jpg";